(function ($, window, document) {

function onDOMContentLoaded() {
  $('.update-template').on('click', updateCMStemplate);
  $('.update').on('click', updateCMS);
  $('.reload').on('click', reloadPreviews);
  $('.release').on('click', release);
  $('.rollback').on('click', rollback);
  $('#location').on('blur', reloadLocation);
  $('#location').on('keypress', detectReturn);

  function updateCMStemplate(event) {
    event.preventDefault();
    var loaderImage = new Image();
    $(loaderImage)
      .on('error', function () {
        alert('Tapahtui virhe. Kokeile uudelleen, jos ei toimi ota yhteyttä kehittäjiin');
      })
      .on('load', delayedUpdateCMS)
      .attr('src', event.currentTarget.href);
  }

  function delayedUpdateCMS() {
    setTimeout(updateCMS, 10000);
    $('#loading-template').removeClass('hidden');
  }

  function updateCMS(event) {
    var loaderImage = new Image();
    var src;

    if (event) {
      event.preventDefault();
      src = event.currentTarget.href;
    } else {
      src = $('.update').attr('href');
    }

    $(loaderImage)
      .on('error', function () {
        alert('Tapahtui virhe. Kokeile uudelleen, jos ei toimi ota yhteyttä kehittäjiin');
      })
      .on('load', delayedReloadPreviews)
      .attr('src', src);
  }

  function delayedReloadPreviews() {
    setTimeout(reloadPreviews, 10000);
    $('#loading-template').addClass('hidden');
    $('#loading').removeClass('hidden');
  }

  function reloadPreviews(event) {
    var url = window.location.href + '#';
    if (event) {
      event.preventDefault();
      url = event.currentTarget.href;
    }

    var $iframes = $('iframe');
    if (url === window.location.href + '#') {
      url = $iframes.attr('src');
    }

    _reloadPreviews(url);
  }

  function _reloadPreviews(url) {
    var $iframes = $('iframe');
    $iframes.each(function (index, value) {
      value.src = url;
    });

    $('#loading-template').addClass('hidden');
    $('#loading').addClass('hidden');
  }

  function detectReturn(event) {
    if (event.which == 13) {
      event.currentTarget.blur();
    }
  }

  function reloadLocation(event) {
    _reloadPreviews(event.currentTarget.value);
  }

  function release() {
    event.preventDefault();
    alert('Not implemented yet');
  }

  function rollback() {
    event.preventDefault();
    alert('Not implemented yet');
  }
}
if (document.readyState == 'loading') {
  document.addEventListener("DOMContentLoaded", onDOMContentLoaded);
} else {
  onDOMContentLoaded();
}

})(jQuery, window, document);
